/**
 * Shared device configuration for responsive preview
 * Used by PageEditorNew and PreviewModal
 */

export type DeviceType = "desktop" | "tablet" | "mobile";

export interface DeviceSize {
  width: number;
  height: number;
  label: string;
}

/**
 * Device sizes for preview modes
 */
export const deviceSizes: Record<DeviceType, DeviceSize> = {
  desktop: { width: 1280, height: 800, label: "Desktop (1280×800)" },
  tablet: { width: 768, height: 1024, label: "Tablet (768×1024)" },
  mobile: { width: 375, height: 667, label: "Mobile (375×667)" },
};

/**
 * Get width for device type
 */
export const getDeviceWidth = (device: DeviceType): number | "100%" => {
  return device === "desktop" ? "100%" : deviceSizes[device].width;
};
